import { Component, Input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ArrowIconComponent } from '../../arrow-icon/arrow-icon.component';
import { OverviewTooltipComponent } from '../overview-tooltip/overview-tooltip.component';
import { TippyDirective } from '@ngneat/helipopper';
import { CardType, Metric, Tooltip, Trend, ValueType } from '../types';
import {LoaderComponent} from '../../loader/loader.component';
import { TooltipIconComponent } from '../../tooltip-icon/tooltip-icon.component';
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-overview-card',
  imports: [
    NgOptimizedImage,
    CommonModule,
    MatTooltipModule,
    ArrowIconComponent,
    OverviewTooltipComponent,
    TippyDirective,
    LoaderComponent,
    TooltipIconComponent,
    AssetVersionPipe
  ],
  templateUrl: './overview-card.component.html',
  styleUrl: './overview-card.component.scss',
})
export class OverviewCardComponent {
  @Input() cardWidth: string = '185px';
  @Input() cardHeight?: string;
  @Input() type?: CardType;
  @Input() iconPath?: string;
  @Input() title?: string;
  @Input() value?: string;
  @Input() valueType?: ValueType;
  @Input() valueDescription?: string;
  @Input() metrics?: Metric[];
  @Input() trend?: Trend;
  @Input() tooltip?: Tooltip[];
  @Input() titleTooltip?: string;
  @Input() titleTooltipPlace: 'above' | 'below' = 'below';
  @Input() loading = false;

  trendTooltip = 'Percentage increase or decrease compared to the previous period.';

  ngOnInit(): void {
    if (!this.type) {
      throw new Error("You must provide type");
    }
  }

  protected getTooltip(hoveredMetric?: Metric): Tooltip[] {
    if (hoveredMetric) {
      const metric = this.metrics?.find(m => m.title === hoveredMetric.title);
      return metric?.tooltip || [];
    } else {
      return this.tooltip || [];
    }
  }
}
